import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isSplitScreen: false
};

const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setSplitscreenMode(state, action) {
      state.isSplitScreen = action.payload;
    }
  }
});

export const { setSplitscreenMode } = layoutSlice.actions;

export default layoutSlice.reducer;
